module.exports = __webpack_public_path__ + "static/media/top-view.e3943a9d.jpg";